import React from "react";
import {
  Card,
  CardContent,
  Typography,
  Box,
  Button,
  Divider,
  Link,
  IconButton,
  Collapse,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import PersonIcon from "@mui/icons-material/Person";
import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";
import NotesIcon from "@mui/icons-material/Notes";
import { useNavigate } from "react-router-dom";

export default function CargoEscortRequestCard({ open, onClose, data }) {
  const navigate = useNavigate();
  if (!data) return null;

  const {
    cargoType,
    pickupLocation,
    deliveryLocation,
    RequesterName,
    RequesterPhoneNo,
    RequesterEmail,
    vehicleNumber,
    receiverName,
    receiverPhone,
    departureDate,
    DriverName,
    DriverEmail,
    DriverPhoneNo,
    arrivalTime,
    instructions,
    waybillImage,
    state,
  } = data;

  const handelData = () => {
    onClose();
    navigate(`/escort`);
  };

  return (
    <Collapse in={open}>
      <Box
        position="fixed"
        top={0}
        left={0}
        width="100vw"
        height="100vh"
        bgcolor="rgba(0,0,0,0.5)"
        zIndex={1300}
      >
        <Box
          position="absolute"
          top="50%"
          left="50%"
          sx={{
            transform: "translate(-50%, -50%)",
            width: "90%",
            maxWidth: 600,
            maxHeight: "90vh",
            overflow: "auto",
            borderRadius: 3,
            boxShadow: 6,
            bgcolor: "background.paper",
          }}
        >
          <Card sx={{ boxShadow: "none" }}>
            <CardContent sx={{ fontSize: 13 }}>
              <Box display="flex" justifyContent="space-between" alignItems="center" mb={0}>
                <Typography variant="h4" sx={{ color: "#000" }}>
                  New Cargo Escort Request
                </Typography>
                <IconButton size="small" onClick={onClose}>
                  <CloseIcon />
                </IconButton>
              </Box>

              <Typography variant="body2" sx={{ color: "#000", fontSize: 13 }} gutterBottom>
                {new Intl.DateTimeFormat("en-US", {
                  dateStyle: "medium",
                  timeStyle: "short",
                }).format(new Date())}
              </Typography>

              <Divider sx={{ my: 1 }} />

              <Box display="flex" alignItems="center" mb={0}>
                <LocalShippingIcon sx={{ mr: 1 }} fontSize="small" />
                <Typography fontWeight="bold">Load Details</Typography>
              </Box>
              <Typography sx={{ fontSize: 14 }}>Cargo Type : {cargoType}</Typography>
              <Link
                href={waybillImage}
                underline="hover"
                sx={{ fontSize: 14, color: "blue" }}
                target="_blank"
                rel="noopener noreferrer"
              >
                Waybill/Receipt document
              </Link>

              <Box mt={2}>
                <Typography fontWeight="bold" gutterBottom>
                  Load Receiver details:
                </Typography>
                <Box display="flex">
                  <Typography sx={{ fontSize: 14 }}>Name: {receiverName}</Typography>
                  <Typography sx={{ fontSize: 14, marginLeft: 5 }}>
                    Address: {deliveryLocation}
                  </Typography>
                </Box>
                <Box display="flex">
                  <Typography sx={{ fontSize: 14 }}>Phone: {receiverPhone}</Typography>
                </Box>
              </Box>

              <Box mt={2}>
                <Box display="flex" alignItems="center" mb={1}>
                  <PersonIcon sx={{ mr: 1 }} fontSize="small" />
                  <Typography fontWeight="bold">Requester</Typography>
                </Box>

                <Box display="flex" flexWrap="wrap">
                  <Typography sx={{ fontSize: 14, mr: 5 }}>Name: {RequesterName}</Typography>
                  <Typography sx={{ fontSize: 14 }}>Email: {RequesterEmail}</Typography>
                </Box>

                <Typography sx={{ fontSize: 14, mt: 1 }}>Phone: {RequesterPhoneNo}</Typography>
              </Box>

              <Box mt={2}>
                <Box display="flex" alignItems="center" mb={1}>
                  <DirectionsCarIcon sx={{ mr: 1 }} fontSize="small" />
                  <Typography fontWeight="bold">Vehicle & Driver</Typography>
                </Box>
                <Box display="flex">
                  <Typography sx={{ fontSize: 14 }}>Vehicle No: {vehicleNumber}</Typography>
                  <Typography sx={{ fontSize: 14, marginLeft: 5 }}>
                    Driver Phone: {DriverPhoneNo}
                  </Typography>
                </Box>
                <Box display="flex">
                  <Typography sx={{ fontSize: 14 }}>Driver Name: {DriverName}</Typography>
                </Box>
              </Box>

              <Box mt={2}>
                <Box display="flex" alignItems="center" mb={1}>
                  <NotesIcon sx={{ mr: 1 }} fontSize="small" />
                  <Typography fontWeight="bold">Additional Notes</Typography>
                </Box>
                <Typography sx={{ fontSize: 14 }}>{instructions}</Typography>
              </Box>

              <Box mt={3} display="flex" justifyContent="center" flexWrap="wrap">
                <Button
                  onClick={handelData}
                  variant="contained"
                  fullWidth
                  sx={{
                    backgroundColor: "#000000",
                    color: "#ffffff",
                    fontWeight: "bold",
                    "&:hover": { backgroundColor: "#333333" },
                  }}
                >
                  ok
                </Button>
              </Box>
            </CardContent>
          </Card>
        </Box>
      </Box>
    </Collapse>
  );
}
